import gsap from "gsap";
import { S as SplitText } from "./splittext";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(SplitText);
  gsap.registerPlugin(ScrollTrigger);

  const textHero = document.querySelector(".explore-programs-animation");

  if (!textHero) {
    return;
  }

  function generateWordTimelines() {
    return allWords.map((word: string, wordIndex: number) => {
      const characters = word.split("");
      const wordElement = wordElements[wordIndex];

      const split = new SplitText(wordElement, {
        type: "chars",
        position: "absolute",
      });

      const tl = gsap.timeline({ ease: "power3.inOut" });

      split.chars.forEach((obj: HTMLDivElement, i: number) => {
        let currentCharacter = obj.innerText;
        let svg = svgs[i % numSVG];
        let svgFilter = svgs.filter((svg) => svg !== svgs[i % numSVG]);
        let svgTwo = gsap.utils.random(svgFilter);

        gsap.set(svg, { rotation: gsap.utils.random(-180, 180) });
        gsap.set(svgTwo, { rotation: gsap.utils.random(-180, 180) });
        let newHTML = `<div></div>
                <div class="originalText" aria-hidden="true">${currentCharacter}</div>`;
        obj.innerHTML = newHTML;

        [...obj.children].forEach((child, index) => {
          gsap.set(child, {
            yPercent: index * 120,
            autoAlpha: 1,
          });
          // animate text in
          tl.to(
            child,
            {
              yPercent: "-=120",
              duration: 0.625,
            },
            i * 0.08
          );
          // animate text out
          tl.to(
            child,
            {
              yPercent: "-=120",
              delay: 2,
              duration: 0.625,
            },
            ">" + i * 0.08
          );
        });
      });
      tl.animationLength = characters.length * 0.08 + 0.5;
      tl.split = split;
      return tl;
    });
  }

  function createMasterTimeline(timelines) {
    const masterTimeline = gsap.timeline({
      repeat: -1,
      scrollTrigger: {
        start: "bottom 90%",
        trigger: "#animated-words",
        // markers: true,
      },
    });

    timelines.forEach((tl, index) => {
      masterTimeline.add(
        tl,
        `-=${timelines[Math.max(index - 1, 0)].animationLength}`
      );
    });

    return masterTimeline;
  }

  const allWords =
    document.querySelector("#animated-words")?.dataset.words.split(" ") || [];

  const wordElements = [...document.querySelectorAll(".animated-word")];
  const svgs = [...textHero.querySelectorAll("svg")];
  const numSVG = svgs.length;
  let timelines = generateWordTimelines();
  let masterTimeline = createMasterTimeline(timelines);

  gsap.to(".animated-word", {
    autoAlpha: 1,
    duration: 0.5,
  });

  let timeout = null as number | null;

  window.addEventListener("resize", () => {
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    timeout = window.requestAnimationFrame(function () {
      // reset everything
      masterTimeline.clear();
      timelines.forEach((tl) => {
        tl.clear();
        tl.split.revert();
        gsap.set(".animated-word", { clearProps: "all" });
      });

      timelines = generateWordTimelines();
      masterTimeline = createMasterTimeline(timelines);
      gsap.to(".animated-word", {
        autoAlpha: 1,
        duration: 0.5,
      });
      masterTimeline.play();
    });
  });
});
